export default {
  type: 'FeatureCollection',
  name: 'Blue Zones',
  crs: {
    type: 'name',
    properties: {
      name: 'urn:ogc:def:crs:OGC:1.3:CRS84',
    },
  },
  features: [
    {
      type: 'Feature',
      properties: {
        Name: 'Сокільники',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [24.008032, 49.774716],
            [24.011518, 49.774729],
            [24.012874, 49.779784],
            [24.01193, 49.787543],
            [24.010127, 49.787543],
            [24.00987, 49.786712],
            [24.008926, 49.786934],
            [24.008926, 49.787377],
            [23.999141, 49.787432],
            [23.998197, 49.786601],
            [23.99545, 49.78638],
            [23.992618, 49.783165],
            [23.99133, 49.783221],
            [23.99176, 49.785659],
            [23.987382, 49.786213],
            [23.987039, 49.783221],
            [23.977598, 49.785604],
            [23.968929, 49.785271],
            [23.968585, 49.78649],
            [23.96438, 49.786656],
            [23.96468, 49.790536],
            [23.964122, 49.797656],
            [23.959623, 49.798735],
            [23.94928, 49.798707],
            [23.946276, 49.798015],
            [23.945418, 49.797239],
            [23.936277, 49.791643],
            [23.933616, 49.790867],
            [23.942235, 49.789039],
            [23.945497, 49.782168],
            [23.947214, 49.781614],
            [23.944553, 49.777124],
            [23.962835, 49.773521],
            [23.951849, 49.760992],
            [23.957194, 49.75892],
            [23.969444, 49.759828],
            [23.972963, 49.760105],
            [23.974594, 49.759773],
            [23.977769, 49.760161],
            [23.981374, 49.760716],
            [23.983349, 49.761658],
            [23.984893, 49.763876],
            [23.98558, 49.766648],
            [23.981632, 49.769697],
            [23.98309, 49.770085],
            [23.984979, 49.77014],
            [23.983091, 49.773743],
            [23.988241, 49.773909],
            [23.993477, 49.772247],
            [23.995279, 49.771581],
            [23.99854, 49.77086],
            [24.002231, 49.77014],
            [24.00472, 49.769752],
            [24.007948, 49.769647],
            [24.008032, 49.774716],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        Name: 'Скнилів',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [23.914522, 49.802669],
            [23.918468, 49.801409],
            [23.916235, 49.797322],
            [23.922243, 49.796186],
            [23.928938, 49.79674],
            [23.92954, 49.796076],
            [23.93014, 49.795743],
            [23.929883, 49.795217],
            [23.930656, 49.795023],
            [23.929539, 49.792059],
            [23.931857, 49.791117],
            [23.933616, 49.790867],
            [23.936277, 49.791643],
            [23.945418, 49.797239],
            [23.946276, 49.798015],
            [23.94928, 49.798707],
            [23.959623, 49.798735],
            [23.962445, 49.802603],
            [23.962102, 49.804929],
            [23.95575, 49.807477],
            [23.952832, 49.807145],
            [23.951459, 49.807699],
            [23.938852, 49.809122],
            [23.931718, 49.80925],
            [23.92778, 49.810534],
            [23.922963, 49.811355],
            [23.914522, 49.802669],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        Name: 'Лапаївка',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [23.893171, 49.816685],
            [23.89343, 49.80825],
            [23.902741, 49.807266],
            [23.903439, 49.803943],
            [23.905032, 49.802697],
            [23.914522, 49.802669],
            [23.922963, 49.811355],
            [23.918126, 49.810839],
            [23.915594, 49.811919],
            [23.912354, 49.812612],
            [23.909672, 49.81383],
            [23.906754, 49.815478],
            [23.905531, 49.816336],
            [23.903514, 49.818676],
            [23.893171, 49.816685],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        Name: 'Холодновідка',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [23.912902, 49.820604],
            [23.903192, 49.818818],
            [23.90603, 49.815907],
            [23.910499, 49.813411],
            [23.918126, 49.810839],
            [23.922963, 49.811355],
            [23.918878, 49.815446],
            [23.912902, 49.820604],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        Name: 'Зимна Вода',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [23.912397, 49.82045],
            [23.907805, 49.826984],
            [23.903213, 49.832521],
            [23.883257, 49.83205],
            [23.880554, 49.832493],
            [23.876648, 49.833656],
            [23.873687, 49.834763],
            [23.867894, 49.835649],
            [23.864031, 49.835981],
            [23.860984, 49.835953],
            [23.858967, 49.834071],
            [23.860426, 49.831331],
            [23.858881, 49.829393],
            [23.858753, 49.827234],
            [23.862915, 49.82704],
            [23.863173, 49.82978],
            [23.866392, 49.829559],
            [23.868752, 49.829338],
            [23.869653, 49.82117],
            [23.868924, 49.820616],
            [23.869739, 49.820616],
            [23.868002, 49.817141],
            [23.870855, 49.817792],
            [23.871756, 49.817709],
            [23.874975, 49.818152],
            [23.879996, 49.818955],
            [23.881584, 49.819066],
            [23.881755, 49.819371],
            [23.885489, 49.819786],
            [23.885532, 49.817294],
            [23.89081, 49.818706],
            [23.893171, 49.816685],
            [23.912397, 49.82045],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        Name: 'Рудне',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [23.896494, 49.843049],
            [23.886838, 49.842994],
            [23.887224, 49.839202],
            [23.879499, 49.842523],
            [23.873019, 49.844876],
            [23.875465, 49.845872],
            [23.872461, 49.847311],
            [23.865895, 49.848113],
            [23.857226, 49.841388],
            [23.857398, 49.835964],
            [23.864031, 49.835981],
            [23.868341, 49.835659],
            [23.873687, 49.834763],
            [23.876648, 49.833656],
            [23.880554, 49.832493],
            [23.883257, 49.83205],
            [23.903213, 49.832521],
            [23.898253, 49.839064],
            [23.896494, 49.843049],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        Name: 'Підрясне',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [23.896834, 49.847942],
            [23.898894, 49.870296],
            [23.898122, 49.871071],
            [23.89692, 49.871956],
            [23.89529, 49.872122],
            [23.893401, 49.87273],
            [23.891599, 49.872509],
            [23.889968, 49.872509],
            [23.888938, 49.873118],
            [23.888766, 49.87439],
            [23.885762, 49.875109],
            [23.858468, 49.878041],
            [23.859412, 49.8771],
            [23.861129, 49.87616],
            [23.861129, 49.875662],
            [23.861987, 49.874501],
            [23.861386, 49.874058],
            [23.86379, 49.873394],
            [23.863189, 49.872565],
            [23.866794, 49.871182],
            [23.866622, 49.869301],
            [23.870313, 49.86919],
            [23.874862, 49.866535],
            [23.869712, 49.863602],
            [23.873231, 49.862219],
            [23.877523, 49.855801],
            [23.879754, 49.854915],
            [23.886838, 49.842994],
            [23.891857, 49.842961],
            [23.896494, 49.843049],
            [23.896834, 49.847942],
          ],
          [
            [23.893659, 49.849326],
            [23.895976, 49.848053],
            [23.896834, 49.847942],
            [23.893659, 49.849326],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        Name: 'Рясне-Руське',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [23.9239107, 49.8787663],
            [23.932013, 49.89223],
            [23.931842, 49.8928386],
            [23.928924, 49.895106],
            [23.926863, 49.89682],
            [23.925061, 49.898258],
            [23.920598, 49.902349],
            [23.919772, 49.9029566],
            [23.916884, 49.9041506],
            [23.917914, 49.9058366],
            [23.91388, 49.9069706],
            [23.910061, 49.9068046],
            [23.904739, 49.9087386],
            [23.8590529, 49.8781826],
            [23.8857619, 49.8752196],
            [23.8890719, 49.8741596],
            [23.8889379, 49.8732286],
            [23.8899679, 49.8726196],
            [23.89692, 49.8720666],
            [23.898894, 49.8704066],
            [23.89905, 49.8692846],
            [23.898492, 49.8640356],
            [23.908449, 49.8661106],
            [23.91068, 49.8658196],
            [23.915581, 49.8736806],
            [23.923714, 49.8730856],
            [23.924326, 49.8761596],
            [23.929497, 49.8758686],
            [23.9239107, 49.8787663],
          ],
          [
            [23.92386, 49.8787926],
            [23.92386, 49.878682],
            [23.9239107, 49.8787663],
            [23.92386, 49.8787926],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        Name: 'Рясне 2',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [23.924079, 49.874261],
            [23.933456, 49.873155],
            [23.937597, 49.874579],
            [23.942125, 49.874261],
            [23.943047, 49.87722],
            [23.944764, 49.879212],
            [23.943391, 49.879543],
            [23.943906, 49.880981],
            [23.942742, 49.880783],
            [23.94065, 49.879774],
            [23.937565, 49.878234],
            [23.932566, 49.878787],
            [23.930291, 49.878773],
            [23.92386, 49.878682],
            [23.929497, 49.875758],
            [23.924326, 49.876049],
            [23.924079, 49.874261],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        Name: 'Білогорща',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [23.9485488, 49.8452484],
            [23.9466713, 49.8460527],
            [23.9447026, 49.8468743],
            [23.9428063, 49.8476975],
            [23.9409099, 49.8485069],
            [23.9384979, 49.8495568],
            [23.9344217, 49.8507189],
            [23.9270268, 49.851952],
            [23.9247445, 49.8520673],
            [23.9227055, 49.8522681],
            [23.9155811, 49.8539838],
            [23.919263, 49.8652528],
            [23.9117185, 49.865991],
            [23.91068, 49.865709],
            [23.908449, 49.866],
            [23.898492, 49.863925],
            [23.896494, 49.843049],
            [23.902706, 49.83356],
            [23.909745, 49.8380992],
            [23.9224383, 49.8395201],
            [23.9303133, 49.8406133],
            [23.9308283, 49.8424261],
            [23.9331457, 49.8438929],
            [23.9412352, 49.8426752],
            [23.9438745, 49.8437269],
            [23.9483864, 49.8440511],
            [23.9490191, 49.845064],
            [23.9485488, 49.8452484],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        Name: 'Брюховичі',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [23.971582, 49.884046],
            [23.97244, 49.88554],
            [23.974844, 49.89129],
            [23.970895, 49.893668],
            [23.968148, 49.894387],
            [23.964973, 49.897206],
            [23.962741, 49.898146],
            [23.964028, 49.899474],
            [23.962998, 49.902072],
            [23.964973, 49.903509],
            [23.972182, 49.904173],
            [23.974457, 49.909341],
            [23.973642, 49.91064],
            [23.966088, 49.914343],
            [23.96832, 49.916444],
            [23.969522, 49.917825],
            [23.972011, 49.918488],
            [23.973126, 49.919041],
            [23.97862, 49.919152],
            [23.982654, 49.920809],
            [23.983512, 49.921638],
            [23.983254, 49.924512],
            [23.972096, 49.923572],
            [23.967118, 49.922522],
            [23.957505, 49.917825],
            [23.932443, 49.916665],
            [23.933044, 49.916941],
            [23.932786, 49.917493],
            [23.930488, 49.917334],
            [23.927002, 49.914761],
            [23.924718, 49.911856],
            [23.924804, 49.910751],
            [23.92386, 49.9097],
            [23.92695, 49.906992],
            [23.926692, 49.905168],
            [23.925448, 49.902432],
            [23.924289, 49.900856],
            [23.920598, 49.902349],
            [23.925061, 49.898258],
            [23.926863, 49.89682],
            [23.928924, 49.895106],
            [23.931155, 49.893336],
            [23.931842, 49.892728],
            [23.932013, 49.89223],
            [23.92386, 49.878682],
            [23.930291, 49.878773],
            [23.937565, 49.878234],
            [23.942742, 49.880783],
            [23.950553, 49.881115],
            [23.953214, 49.880894],
            [23.957848, 49.881226],
            [23.966565, 49.879101],
            [23.96686, 49.882221],
            [23.971582, 49.884046],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        Name: 'Малехів',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [24.077973, 49.874012],
            [24.08584, 49.879459],
            [24.090947, 49.881838],
            [24.095926, 49.883054],
            [24.094767, 49.884188],
            [24.095153, 49.885156],
            [24.095411, 49.886787],
            [24.095239, 49.887285],
            [24.09481, 49.888142],
            [24.094338, 49.88828],
            [24.093823, 49.888612],
            [24.093909, 49.888944],
            [24.094466, 49.888972],
            [24.093694, 49.890907],
            [24.080262, 49.886981],
            [24.079661, 49.888557],
            [24.074339, 49.88817],
            [24.068717, 49.89157],
            [24.040464, 49.892672],
            [24.059463, 49.886132],
            [24.063554, 49.875893],
            [24.077973, 49.874012],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        Name: 'Муроване',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [24.088951, 49.869892],
            [24.088779, 49.868952],
            [24.088565, 49.867955],
            [24.087857, 49.865024],
            [24.091363, 49.863833],
            [24.083981, 49.862616],
            [24.082093, 49.859407],
            [24.089818, 49.855312],
            [24.089303, 49.854094],
            [24.092564, 49.853541],
            [24.093766, 49.852213],
            [24.099602, 49.851549],
            [24.098401, 49.847786],
            [24.095483, 49.846014],
            [24.103722, 49.84369],
            [24.104581, 49.842361],
            [24.113507, 49.843911],
            [24.11797, 49.843136],
            [24.118849, 49.843759],
            [24.110581, 49.872879],
            [24.110109, 49.874622],
            [24.110323, 49.877221],
            [24.10762, 49.877553],
            [24.107705, 49.878798],
            [24.102427, 49.879157],
            [24.101955, 49.878327],
            [24.097749, 49.879793],
            [24.098221, 49.881093],
            [24.095926, 49.883054],
            [24.090947, 49.881838],
            [24.08584, 49.879459],
            [24.083372, 49.877885],
            [24.078394, 49.87429],
            [24.088093, 49.873266],
            [24.089209, 49.870279],
            [24.089037, 49.870099],
            [24.088951, 49.869892],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        Name: 'Лисиничі',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [24.11797, 49.843136],
            [24.118098, 49.841614],
            [24.118142, 49.841365],
            [24.115224, 49.840147],
            [24.114194, 49.840922],
            [24.111619, 49.839704],
            [24.112649, 49.838376],
            [24.112992, 49.833283],
            [24.112476, 49.833172],
            [24.112626, 49.832895],
            [24.128486, 49.826463],
            [24.142098, 49.826874],
            [24.150137, 49.827128],
            [24.154772, 49.830284],
            [24.13093, 49.838251],
            [24.129192, 49.838251],
            [24.129535, 49.839746],
            [24.126853, 49.839912],
            [24.126338, 49.841088],
            [24.124278, 49.841227],
            [24.125008, 49.844036],
            [24.118849, 49.843759],
            [24.11797, 49.843136],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        Name: 'Пасіки-Зубрицькі',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [24.069103, 49.780985],
            [24.073566, 49.777854],
            [24.076313, 49.775249],
            [24.08054, 49.767052],
            [24.080905, 49.766241],
            [24.067706, 49.761652],
            [24.060496, 49.754056],
            [24.091419, 49.763247],
            [24.096183, 49.763469],
            [24.09923, 49.764301],
            [24.100646, 49.764605],
            [24.104165, 49.768348],
            [24.104723, 49.769539],
            [24.123302, 49.779198],
            [24.107541, 49.783874],
            [24.094681, 49.780431],
            [24.090518, 49.7796],
            [24.07969, 49.783549],
            [24.070935, 49.781],
            [24.069103, 49.780985],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        Name: 'Зубра',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [24.060496, 49.754049],
            [24.061096, 49.754548],
            [24.061954, 49.755574],
            [24.062427, 49.756046],
            [24.063435, 49.757098],
            [24.0638, 49.757514],
            [24.064959, 49.758804],
            [24.065903, 49.759649],
            [24.067061, 49.761035],
            [24.067448, 49.761506],
            [24.070023, 49.762561],
            [24.080905, 49.766234],
            [24.079068, 49.769926],
            [24.077748, 49.772123],
            [24.076803, 49.774506],
            [24.073566, 49.777854],
            [24.069103, 49.780985],
            [24.065388, 49.780825],
            [24.064294, 49.780867],
            [24.063735, 49.780811],
            [24.062942, 49.780812],
            [24.062577, 49.780783],
            [24.062319, 49.780783],
            [24.061804, 49.780756],
            [24.060925, 49.780742],
            [24.060238, 49.78077],
            [24.059702, 49.780728],
            [24.054294, 49.780686],
            [24.051881, 49.78066],
            [24.051537, 49.78587],
            [24.049477, 49.785537],
            [24.049477, 49.787311],
            [24.047761, 49.787532],
            [24.047589, 49.789195],
            [24.044156, 49.789084],
            [24.042096, 49.788197],
            [24.043469, 49.787089],
            [24.040894, 49.785648],
            [24.039295, 49.785591],
            [24.038094, 49.783208],
            [24.04127, 49.782211],
            [24.039553, 49.777333],
            [24.036206, 49.778331],
            [24.035572, 49.778554],
            [24.03509, 49.777472],
            [24.034832, 49.776668],
            [24.034661, 49.775726],
            [24.037836, 49.775116],
            [24.037407, 49.772012],
            [24.035433, 49.771901],
            [24.035433, 49.770848],
            [24.034832, 49.770904],
            [24.034746, 49.769407],
            [24.034317, 49.768852],
            [24.034489, 49.767522],
            [24.039896, 49.7673],
            [24.040583, 49.76281],
            [24.041441, 49.76037],
            [24.042986, 49.760481],
            [24.042729, 49.759372],
            [24.041956, 49.758928],
            [24.043844, 49.755102],
            [24.045046, 49.755158],
            [24.045561, 49.754714],
            [24.047964, 49.755269],
            [24.049252, 49.753217],
            [24.049938, 49.753439],
            [24.050539, 49.752663],
            [24.05835, 49.754382],
            [24.060496, 49.754049],
          ],
        ],
      },
    },
  ],
};
